module.exports = __webpack_public_path__ + "img/icon-lupa.6820bdf3.svg";